// extracted by css-extract-rspack-plugin
export default {"tags":"tags--wOSl3vGpw43iYPa4"};